import React, {useState} from 'react';
import {Alert, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import Button from "./Button";
import QRCode from "react-qr-code";
import appUserRoutes from "../appUserRoutes";
import {useTranslation} from "react-i18next";

const LoginQrCodeModal = props => {
  const { t } = useTranslation('login_qr_code_modal')
  const [modalOpen, setModalOpen] = useState(false)

  const getLoginUrl = () => {
    return window.location.protocol + '//' + window.location.host + appUserRoutes.vehicleNew + '?auth=' + localStorage.getItem('jwt')
  }

  return (
    <div>
      <Button size={'sm'} onClick={() => setModalOpen(true)}>{t('btn_show_code')}</Button>
      {modalOpen && <Modal isOpen size={'md'} toggle={() => setModalOpen(false)}>
        <ModalHeader toggle={() => setModalOpen(false)}>{t('modal.header')}</ModalHeader>
        <ModalBody>
          <Alert color={'danger'}>{t('modal.body_alert')}</Alert>
          <div className="d-flex align-items-center justify-content-center">
            <QRCode value={getLoginUrl()}/>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color={'secondary'} onClick={() => setModalOpen(false)}>{t('common:btn.close')}</Button>
        </ModalFooter>
      </Modal>}
    </div>
  );
};

LoginQrCodeModal.propTypes = {

};

export default LoginQrCodeModal;